<template>
  <div class="container">
    <div class="custom-button-a" style="width: 200px; height: 70px; background-color: transparent; position: relative;">
        <input type="file" :id="file_id" ref="file" v-on:change="handleFileUpload()" style="display:none" :disabled="isDisabled"/>
        <label :for="file_id" :style="textStyle" style="position: absolute; font-family: Open-Sans, sans-serif; font-size: 25px; z-index: 3; text-align: center; width: 100%; height: 40%; margin-top: 10%"> Subir Imagen </label>
        <img style="position:absolute; z-index: 2;" src="/pages/img/svgGenericButton01.svg">
    </div>
  </div>
</template>

<script>
    export default {
        props: {
            number:{
                default:"0",
                type: String
            },
            textColor:{
                default:"#FFFFFF",
                type: String
            },
            disabled:{
                default:false,
                type: Boolean 
            }
        },
        data () {
            return {
                dbId: "undefined",
                file_id: null
            }
        },
        computed: {
            eventId(){
                return `${this.dbId}_image_updated`;
            },
            textStyle(){
                return {
                color: this.textColor
                };
            },
            isDisabled: function(){
                return this.disabled;
            }
        },
        mounted () {
            this.dbId = `${this.$route.params.type}-${this.$route.params.chapter}-${this.$route.params.number}-imageUpload-${this.number}`;
            this.file_id = this._uid;
        },        
        methods: {
            handleFileUpload(){
                var blob = this.$refs.file.files[0];
                var nestedThis = this; 
                this.$db.images.put({
                    id: this.dbId,
                    blob: blob
                }).catch(function(error){
                    console.log("error uploading file" + error);
                }).then(function(){
                    nestedThis.$eventHub.$emit(nestedThis.eventId)
                });
            }
        }
    }
</script>